import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Loader from "../../../components/molecules/Loader";
import { useNavigate } from "react-router-dom";
import { getAllThirdPartyLabApplication } from "../../../api/apimethods";
import Header from "../../../components/molecules/Header/Header";
import Footer from "../../../components/molecules/Footer/Footer";
import "../../../styles/LabStyles.css";
import LabResultGrid from "./LabResultGrid";
import { NotifyType } from "../../../utils/NotifyType";
import { notify } from "../../../utils";
const LabresultDashboard = () => {
  const enquiryDashboard = [
    {
      columnName: "S.No",
      sortKey: "SNo",
    },
    {
      columnName: "Purpose Code",
      sortKey: "purposeCode",
    },

    {
      columnName: "Applicant's Ref No",
      sortKey: "applicationNumber",
    },
    {
      columnName: "Test Description",
      sortKey: "testDescription",
    },

    {
      columnName: "Application Date",
      sortKey: "applicationDate",
    },
    {
      columnName: "Action",
      sortKey: "",
    },
  ];

  const [data, setData] = useState<any[]>([]);
  const { message } = notify();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [headers, setHeaders] = useState<any[]>(enquiryDashboard);
  const [pageLoading, setPageLoading] = useState<boolean>(false);

  useEffect(() => {
    getAllRecords();
  }, []);

  const getAllRecords = async () => {
    try {
      setIsLoading(true);
      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "");
      let NRIC = userInfo?.user?.idNo || "";
      let UEN = userInfo?.user?.uen || null;
      let role = userInfo?.user?.role || "";

      const customerIdentifier = role === "CorpPass" ? UEN : NRIC;
      const responses = await getAllThirdPartyLabApplication(
        customerIdentifier
      );

      if (responses.data.length === 0) {
        message(
          NotifyType.Error,
          "You are not authorized to submit laboratory test results. Please contact Nparks for assistance."
        );
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        const filteredData = responses.data.filter(
          (item: any) => item.typeOfService === "CAVS Laboratory Services"
        );
        setData(filteredData);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };
  return (
    <>
      <Header />
      <center>
        {" "}
        <h3 className="savedraft">Submit Laboratory Results</h3>
      </center>
      <Container>
        <div className="mt-3">
          <br />
          {pageLoading ? <Loader /> : null}

          <LabResultGrid
            data={data}
            isLoading={isLoading}
            headerColumns={headers}
            setData={setData}
          />
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default LabresultDashboard;
